var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {
            //Accordion - Container
            var $listContainer = $('dl.description-list');
            $listContainer.on('click', 'dt:not(.active)', function(){
                $listContainer.find('dt.active').removeClass('active');
                $listContainer.find('dd').slideUp(200);
                $(this).addClass('active').next('dd').slideDown(200);
            });
            $listContainer.on('click', 'dt.active', function(){
                $(this).removeClass('active').next('dd').slideUp();
            });
            // open question if url has id hash
            if (window.location.hash) {
                $listContainer.each(function() {
                    const copiedUrl = $( this ).parent().attr( "id" );
                    if (`#${copiedUrl}` === window.location.hash) {
                        $( this ).find('dt').addClass('active').next('dd').slideDown(200);
                    }
                });
            }
        };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=faq', initializeBlock);
    }
});
